module.exports = __webpack_public_path__ + "img/1484438623.9bc47795.jpg";